module.exports = __webpack_public_path__ + "318dc4ee3f2048f605b0e6cdca861604.jpg";